export const component = ['productCustomization'];
function path(subpath) {
    return [...component, ...subpath];
}
export const selectedIngredients = path(['selectedIngredients']);
export const modes = path(['modes']);
export const ingredientGroups = path(['ingredientGroups']);
export const currencyCode = path(['currencyCode']);
export const localeCode = path(['localeCode']);
export const texts = path(['texts']);
export const basePrice = path(['basePrice']);
export const submitUrl = path(['submitUrl']);
export const csrfToken = path(['csrfToken']);
